import * as React from 'react';
import { pathOr } from 'ramda';

import { formatPhoneNumber, phoneValidator } from './utils';
import { IBaseQuestionProps, TAnswersState } from '../FormContainer/types/internal';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { useSimpleForm } from '../../utils/useSimpleForm';
import { pickOnlyMeaning } from '../../utils/pickOnlyMeaning';
import { ChangeEventHandler } from 'react';
import { PhoneField } from '../../components/PhoneVerification';
import { clearPhoneNumber } from './utils/clearPhoneNumber';
import { getInitialPhoneValue } from './utils/getInitialPhoneValue';

/** Контейнер для шага, состоящего из поля ввода телефона (без подтверждения) */
export const PhoneValueContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const {
    question: { answerField, title, required, placeholder },
    setAnswersState,
    setNextStep,
    answersState,
  } = props;

  const {
    handleSubmit,
    handleChange: onChange,
    values,
    errors,
    isSubmitDisabled,
  } = useSimpleForm({
    onSubmit(values) {
      setAnswersState(prevState => {
        const value = clearPhoneNumber(values[answerField] as string);
        const nextAnswersState: TAnswersState = {
          ...prevState,
          [answerField]: {
            answerField,
            value,
          },
        };

        setNextStep(nextAnswersState);

        return nextAnswersState;
      });
    },
    validators: {
      [answerField]: phoneValidator(required),
    },
    initialValues: pickOnlyMeaning({
      [answerField]: getInitialPhoneValue(answerField, answersState),
    }),
    required,
  });

  const handleChange = React.useCallback<ChangeEventHandler<HTMLInputElement>>(
    ({ target: { value } }) => {
      const formatted = formatPhoneNumber(value);
      onChange(answerField, formatted);
    },
    [onChange, answerField],
  );

  return (
    <QuestionLayoutContainer title={title} onSubmit={handleSubmit} disableSubmit={isSubmitDisabled}>
      <PhoneField
        value={pathOr('', [answerField], values)}
        isValid={!errors[answerField]}
        errorMessage={errors[answerField]}
        inputName={answerField}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </QuestionLayoutContainer>
  );
};
